import React from "react";
import { ChipProps } from "./types";

export const ToggleChip: React.FC<ChipProps> = ({
  label,
  isActive,
  onClick,
}) => {
  return (
    <div
      className={`flex flex-row gap-2 px-6 py-2 items-center justify-between cursor-pointer rounded-sm transition-colors duration-300 ${
        isActive
          ? "bg-black/90 text-white"
          : "bg-transparent text-black border border-solid border-black"
      }`}
      onClick={onClick}
    >
      <div className="text-sm md:text-base text-center">{label}</div>
    </div>
  );
};

export default ToggleChip;
